mutation PayCycleUrgentUpdate($input: PayCycleUrgentUpdateInput!) {
  payCycleUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
